import SetPiece from './set-piece.entity';
import { SosListResponse } from '../sos-response';
import { EpisodicBaseESDoc } from '../types';
import SetPieceSet from '../set-piece-sets/set-piece-set.entity';

export interface SetPieceESDoc extends EpisodicBaseESDoc {
	name: string;
	brand: string;
	description: string;
	storage_location_name: string;
	storage_location_id: number;
}

export interface SetPiecesForSetListResponse extends SosListResponse {
	listed: {
		SetPiece: SetPiece[];
		SetPieceSet: SetPieceSet[];
	};
}

export interface SetPiecesWithoutSetListResponse {
	listed: {
		SetPiece: SetPiece[];
	};
}
